import React from 'react'
import "./testimonialSection.css"
import TestimonialCard from '../../../components/testimonialCard/TestimonialCard'
const t_data_obj =[
  {
      name:"Dewang Agarwal",
      job:"Placed at Google (55Lpa)",
      c_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/500px-Google_2015_logo.svg.png",
      c_alt: "Google logo",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c3e164305b592822db0076_gogte.png",
      cw: "",
      ch: "",
      sw: "",
      sh: "",
  },
  {
      name:"Kanishk Pathak",
      job:"Placed at Meta (35Lpa)",
      c_img: "https://i.pinimg.com/originals/50/de/9c/50de9c655bb90531b36c68f8f2ba3686.png",
      c_alt: "Razorpay",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec4513710f2125dcd6c2_alumni-13.png",
  },
  {
      name:"Dewang Agarwal",
      job:"Placed at Zupee (16Lpa)",
      c_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c277325144f405f8385e29_zupee.png",
      c_alt: "Zupee",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec424ee6b66c880a9b0d_alumni-7.png"
  },
  {
      name:"Addya Joshi",
      job:"Intern at Flipkart (85k/mn)",
      c_img: "https://cdn.worldvectorlogo.com/logos/flipkart.svg",
      c_alt: "Flifkart",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec44778f242b7da6271b_alumni-10.png"
  },
  {
      name:"Yash Sharma",
      job:"Placed at Zomato (18Lpa)",
      c_img: "https://cdn.worldvectorlogo.com/logos/zomato-1.svg",
      c_alt: "Zomato",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec41953bfe3e76a374f7_alumni-3.png"
  },
  {
      name:"Swati Taparia",
      job:"Placed at MX Player (16Lpa)",
      c_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c27730bc1eb2383ad5e321_mx.png",
      c_alt: "MXplayer",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec42cf28f418e7e8484f_alumni-5.png"
  },
  {
      name:"Manav Jain",
      job:"Intern at Swiggy (70k/mn)",
      c_img: "https://cdn.worldvectorlogo.com/logos/swiggy-logo.svg",
      c_alt: "Swiggy",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec42d5503e9493092113_alumni-8.png"
  },
  {
      name:"Ananya Dey",
      job:"Placed at Paytm (22Lpa)",
      c_img: "https://cdn.worldvectorlogo.com/logos/paytm-1.svg",
      c_alt: "Paytm",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec26f942fe38de08bc17_alumni-17.png"
  },
  {
      name:"Dewang Agarwal",
      job:"Intern at Leskart (70k/mn)",
      c_img: "https://pbs.twimg.com/media/BPR-HnzCcAAmJnF.png",
      c_alt: "Lenskart",
      s_img: "https://global-uploads.webflow.com/5da0478a951135b39339e016/60c8ec41fc6de35a4dd4af91_alumni-1.png"
  }
  
]

function TestimonialSection() {
  const obj = {
    title: "The best decision I made during my tech interview prep!",
    message: "his program was a game-changer for me. The curated set of 150 DSA questions covered everything I needed to know for my interviews with FANG companies. It saved me countless hours of sifting through random questions online. Thanks to this targeted approach, I received offers from two top-tier companies!",
    name: "Dewang Agarwal",
    job: "Software Engineer at Google"
  }
  return (
    <section id='testimonialSection' className='tes-section'>
        <div className='card-wp'>
        <div className='tas-header-box'>
          <h1 className='text rubik-gfont'>Testimonials</h1>
        </div>
        </div>
        
        <div className="testimonials">
                    {
                        t_data_obj.map((obj, index)=>(
                            <div key={index} className="t-card">
                                <div className="t-data">
                                    <h2>{obj.name}</h2>
                                    <p>{obj.job}</p>
                                    <hr/>
                                    <img src={obj.c_img} alt={obj.c_alt} 
                                    width={obj.cw} height={obj.ch}/>
                                </div>
                                <div className="t-img">
                                    <img src={obj.s_img} alt="" width={obj.sw} height={obj.sh}/>
                                </div>
                            </div>
                        ))
                    }
                </div>
    </section>
  )
}

export default TestimonialSection